import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TaskFeed = () => {
  const [filter, setFilter] = useState('all');

  const tasks = [
  {
    id: 'T001',
    title: 'Fungicide Application - North Field',
    description: 'Apply copper-based fungicide to tomato crops in sections A1-A4',
    priority: 'high',
    status: 'in-progress',
    assignee: 'Maria Rodriguez',
    assigneeAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_179730199-1763294404928.png",
    assigneeAvatarAlt: 'Professional headshot of Hispanic woman with long dark hair in agricultural uniform',
    dueTime: '10:30 AM',
    estimatedDuration: '2.5 hours',
    field: 'North Field',
    equipment: 'Sprayer Unit #3',
    weather: 'Optimal',
    progress: 65
  },
  {
    id: 'T002',
    title: 'Pest Monitoring - South Field',
    description: 'Weekly aphid count and thrips assessment in greenhouse sections',
    priority: 'medium',
    status: 'pending',
    assignee: 'James Chen',
    assigneeAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13855f695-1763292275414.png",
    assigneeAvatarAlt: 'Professional headshot of Asian man with short black hair in field work attire',
    dueTime: '2:00 PM',
    estimatedDuration: '1.5 hours',
    field: 'South Field',
    equipment: 'Monitoring Kit #2',
    weather: 'Good',
    progress: 0
  },
  {
    id: 'T003',
    title: 'Herbicide Treatment - East Field',
    description: 'Selective herbicide application for weed control in corn rows',
    priority: 'high',
    status: 'completed',
    assignee: 'Sarah Johnson',
    assigneeAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1db60fb63-1763295621126.png",
    assigneeAvatarAlt: 'Professional headshot of Caucasian woman with blonde hair in agricultural safety gear',
    dueTime: '8:00 AM',
    estimatedDuration: '3 hours',
    field: 'East Field',
    equipment: 'Precision Sprayer #1',
    weather: 'Completed',
    progress: 100
  },
  {
    id: 'T004',
    title: 'Irrigation System Check',
    description: 'Inspect and calibrate drip irrigation system pressure and flow rates',
    priority: 'medium',
    status: 'overdue',
    assignee: 'Michael Torres',
    assigneeAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_138df7967-1763295321074.png",
    assigneeAvatarAlt: 'Professional headshot of Hispanic man with beard in maintenance uniform',
    dueTime: '9:00 AM',
    estimatedDuration: '2 hours',
    field: 'West Field',
    equipment: 'Pressure Gauge Kit',
    weather: 'Overdue',
    progress: 25
  },
  {
    id: 'T005',
    title: 'Insecticide Application - Central Field',
    description: 'Targeted treatment for cucumber beetle infestation in organic section',
    priority: 'urgent',
    status: 'pending',
    assignee: 'Lisa Park',
    assigneeAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8f8a067-1763301203483.png",
    assigneeAvatarAlt: 'Professional headshot of Asian woman with short black hair in organic farming attire',
    dueTime: '11:00 AM',
    estimatedDuration: '1 hour',
    field: 'Central Field',
    equipment: 'Organic Sprayer #2',
    weather: 'Urgent',
    progress: 0
  }];


  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent':
        return 'bg-error text-error-foreground';
      case 'high':
        return 'bg-warning text-warning-foreground';
      case 'medium':
        return 'bg-accent text-accent-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-success bg-success/10';
      case 'in-progress':
        return 'text-primary bg-primary/10';
      case 'overdue':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted/50';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle';
      case 'in-progress':
        return 'Clock';
      case 'overdue':
        return 'AlertTriangle';
      default:
        return 'Circle';
    }
  };

  const filterOptions = [
  { value: 'all', label: 'All Tasks', count: tasks?.length },
  { value: 'urgent', label: 'Urgent', count: tasks?.filter((t) => t?.priority === 'urgent')?.length },
  { value: 'in-progress', label: 'In Progress', count: tasks?.filter((t) => t?.status === 'in-progress')?.length },
  { value: 'overdue', label: 'Overdue', count: tasks?.filter((t) => t?.status === 'overdue')?.length }];


  const filteredTasks = tasks?.filter((task) => {
    if (filter === 'all') return true;
    return task?.priority === filter || task?.status === filter;
  });

  return (
    <div className="bg-card border border-border rounded-lg agricultural-shadow h-full">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-foreground">Active Tasks</h3>
          <Button variant="outline" size="sm">
            <Icon name="Plus" size={16} />
          </Button>
        </div>

        <div className="flex flex-wrap gap-2">
          {filterOptions?.map((option) =>
          <button
            key={option?.value}
            onClick={() => setFilter(option?.value)}
            className={`
                flex items-center space-x-2 px-3 py-1.5 rounded-md text-xs font-medium smooth-transition
                ${filter === option?.value ?
            'bg-primary text-primary-foreground' :
            'text-muted-foreground hover:text-foreground hover:bg-muted'}
              `
            }>

              <span>{option?.label}</span>
              <span className="bg-background/20 px-1.5 py-0.5 rounded-full text-xs">
                {option?.count}
              </span>
            </button>
          )}
        </div>
      </div>
      <div className="p-4 space-y-4 max-h-96 overflow-y-auto">
        {filteredTasks?.map((task) =>
        <div key={task?.id} className="border border-border rounded-lg p-4 hover:bg-muted/30 smooth-transition">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-start space-x-3">
                <div className={`p-2 rounded-md ${getStatusColor(task?.status)}`}>
                  <Icon name={getStatusIcon(task?.status)} size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-foreground text-sm truncate">{task?.title}</h4>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getPriorityColor(task?.priority)}`}>
                      {task?.priority}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground line-clamp-2">{task?.description}</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mb-3 text-xs text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Clock" size={12} />
                <span>{task?.dueTime}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="MapPin" size={12} />
                <span>{task?.field}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Timer" size={12} />
                <span>{task?.estimatedDuration}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Wrench" size={12} />
                <span>{task?.equipment}</span>
              </div>
            </div>

            {task?.status === 'in-progress' &&
          <div className="mb-3">
                <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                  <span>Progress</span>
                  <span>{task?.progress}%</span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                className="bg-primary h-2 rounded-full smooth-transition"
                style={{ width: `${task?.progress}%` }} />

                </div>
              </div>
          }

            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <img
                src={task?.assigneeAvatar}
                alt={task?.assigneeAvatarAlt}
                className="w-6 h-6 rounded-full object-cover" />

                <span className="text-xs text-muted-foreground">{task?.assignee}</span>
              </div>
              
              <div className="flex items-center space-x-1">
                <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                  <Icon name="MessageSquare" size={14} />
                </Button>
                <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                  <Icon name="MoreHorizontal" size={14} />
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default TaskFeed;